import styled from 'styled-components';

export const StyledLobbyPage = styled.div`
  width: 100%;
`;